/* eslint-disable disable-line */
/* eslint-disable consistent-return */
/* eslint-disable no-console */
import request from 'superagent';

import parseJSON from 'shared-utils/src/parseJSON';
import fetchNewMyCasaProxy from 'shared-utils/src/fetchNewMyCasaProxy';

import { MY_COLLECTIONS_TYPES, MY_COLLECTIONS_IDS } from 'shared-constants/src/mycasa26/collection_configurations';

import { getCollectionNode, setCollectionNode } from 'shared-utils/src/myCasaCollections';

import { getItem, removeItem, setItem } from './UserHelpers';

export const defaultBookmarkData = {
  id: null,
  alerts: {
    mail: null,
    push: null,
  },
};


export const proposeBkmProvinces = () => {
  const node = getCollectionNode(MY_COLLECTIONS_TYPES.SEARCHES, MY_COLLECTIONS_IDS.SAVED);
  return {
    provinces: node?.provinces || [],
  };
};

export const shouldProposeSaveSearchAfterLead = async (body, next) => {
  const should = await request
    .post('/portal-srp/api/v1/mycasa/proposeSaveSearchAfterLead')
    .set('Accept', 'application/json')
    .send(body)
    .withCredentials();

  if (next) return next(should.body);
  return should.body;
};

export const checkBookmarkedSearch = async ({
  portal26Domain,
  currentSearchHash,
  currentSearchSrpUrl,
  saveHistory,
  isAuthenticated,
  finishCall = () => { },
}) => {
  if (!isAuthenticated) {
    finishCall();
    return null;
  }

  if (saveHistory) {
    // salva la ricerca nella history
    try {
      const historyRecord = await fetchNewMyCasaProxy({
        method: 'POST',
        portal26Domain,
        body: JSON.stringify({
          type: MY_COLLECTIONS_TYPES.SEARCHES,
          id: MY_COLLECTIONS_IDS.RECENT,
          data: [{
            url: currentSearchSrpUrl,
            updateDt: new Date().toISOString(),
          }],
        }),
      });
      // aggiungi in localStorage per popolare immediatamente la modale di HP 
      const tosave = await historyRecord.json();
      const recentNode = getCollectionNode(MY_COLLECTIONS_TYPES.SEARCHES, MY_COLLECTIONS_IDS.RECENT);
      const recentData = recentNode?.data || [];
      const tosaveUrls = tosave.map((item) => item.url);// deduplica basata sulla url      
      const filteredRecent = recentData.filter((item) => tosaveUrls.indexOf(item.url) === -1); // deduplica basata sulla url

      setCollectionNode(MY_COLLECTIONS_TYPES.SEARCHES, MY_COLLECTIONS_IDS.RECENT, {
        ...recentNode,
        data: [...tosave, ...filteredRecent],
        count: Math.min(filteredRecent.length + tosave.length, 50),
      });
    } catch (error) {
      console.log('saveHistory error', error);
    }
  }

  let isBoomarked = false;
  let bookmarkData = defaultBookmarkData;

  const node = getCollectionNode(MY_COLLECTIONS_TYPES.SEARCHES, MY_COLLECTIONS_IDS.SAVED);
  const savedsearchesData = node?.data || [];
  const provinces = node?.provinces || [];

  if (savedsearchesData.length) {
    // se l'utente ha ricerche salvate, controlliamo se quella corrente è una di quelle
    const hashesList = savedsearchesData.map((bookmark) => bookmark.hash);
    const currSearchIndex = hashesList.indexOf(currentSearchHash);

    if (currSearchIndex > -1) {
      isBoomarked = true;
      bookmarkData = savedsearchesData[currSearchIndex];
    }
  }

  return {
    searchIsSaved: isBoomarked,
    bookmarkData,
    bookmarks: provinces,
  };
};

export const saveAddressCollection = async (portal26Domain, id, item) => {
  try {
    console.log('saveAddressCollection');
    await fetchNewMyCasaProxy({
      method: 'POST',
      portal26Domain,
      body: JSON.stringify({
        type: MY_COLLECTIONS_TYPES.ADDRESSES,
        id,
        data: Array.isArray(item) ? item : [item],
      }),
    });
  } catch (error) {
    console.log('saveAddressCollection error', error);
  }
};

export const deleteAddressCollection = async (portal26Domain, id, itemIds) => {
  try {
    console.log('deleteAddressCollection');
    await fetchNewMyCasaProxy({
      method: 'DELETE',
      portal26Domain,
      type: MY_COLLECTIONS_TYPES.ADDRESSES,
      id,
      body: JSON.stringify({
        type: MY_COLLECTIONS_TYPES.ADDRESSES,
        id,
        data: itemIds.map((itemId) => ({ id: itemId, deleteDt: new Date().toISOString() })),
      }),
    });
  } catch (error) {
    console.log('deleteAddressCollection error', error);
  }
};


export const callGetFavorites = () => {
  const favNode = getCollectionNode(MY_COLLECTIONS_TYPES.ADS, MY_COLLECTIONS_IDS.SAVED);
  return favNode?.data || [];
};

export const getSearchHiddenAds = (userDiscardedAds, apireq, locations, next) => {
  if (userDiscardedAds.length === 0) {
    if (next) return next(0);
    return Promise.resolve(0);
  }

  const lsClosedList = getItem('__hidddenAdsFeedbackClosed');
  const closedList = parseJSON(lsClosedList) || {};

  const payload = {
    userDiscardedAds,
    apireq,
    locations,
    closedList,
  };

  const uri = '/portal-srp/api/v1/mycasa/hiddentotal';
  const promise = new Promise((resolve) => {
    request
      .post(uri)
      .set('Accept', 'application/json')
      .send(payload)
      .withCredentials()
      .end((err, resApi) => {
        try {
          if (err) {
            resolve(0);
            return;
          }
          const res = JSON.parse(resApi.text);
          const { hiddenTotal, newClosedList } = res;
          if (Object.keys(newClosedList).length > 0) {
            setItem('__hidddenAdsFeedbackClosed', JSON.stringify(newClosedList));
          } else {
            removeItem('__hidddenAdsFeedbackClosed');
          }
          resolve(hiddenTotal);
        } catch (error) {
          console.log(`Error at getSearchHiddenAds: ${JSON.stringify(error)}`);
          resolve(0);
        }
      });
  });

  if (next) {
    promise.then(next);
    return undefined;
  }
  return promise;
};
